module.exports = __webpack_public_path__ + "img/2.f56fb559.svg";